module.exports = "<go-wrapper [title]=\"'Рендер'\"\n            [document]=\"document\"\n            [componentType]=\"componentType\">\n  <nv-render [document]=\"document\"\n             [propertyName]=\"GO_COMPONENTS.RENDER\"></nv-render>\n\n</go-wrapper>\n"


//////////////////
// WEBPACK FOOTER
// /opt/app/develop/src/app/components/go/go-render/go-render.component.html
// module id = ../../../../../src/app/components/go/go-render/go-render.component.html
// module chunks = 0